// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"76fc7e05","787":"2c1792ba","867":"969c48b8"}[chunkId] + ".chunk.js";
};